import { PostApplication } from "../constants";
import { AUTOASSIGN_STATUS, PATH_DEAL_STATUS,autoDocsEmailToParterner,sales_queue_Path } from "../services/constant";
import { decryptUrl, ENCRYPTED_URLS } from "../utils/urlCipher";

export const isExternal = () => {
  if (typeof window === 'undefined' || !window.location || !window.location.href) {
    return false; // Default to false if window or location is unavailable
  }

  if(window.location.hostname === 'localhost' && window.__CONFIG__?.EXTERNAL_LOGIN_LOCAL === "true"){
    return true;
  }
  return window.location.href.includes('clickservonline');
}
export const logout = ()  => {    

    // this breaks when running on localhost but it works on RND and UAT

    sessionStorage.clear();    

    localStorage.clear();

    // Clear all cookies

    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {

      const name = cookie.split('=')[0].trim();

      // Clear with path=/

      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

      // Clear with domain

      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;

    }

    const hrefLower = window.location.href.toLowerCase();
    const hostname = window.location.hostname;
    const hostnameLower = hostname.toLowerCase();

    if (hrefLower.includes('clickservemp')) {

        let ltoVfHostNameForLogout = 'https://' + hostname;

        let pingEnv;

        if (hostnameLower.includes('rnd')) {

          pingEnv = decryptUrl(ENCRYPTED_URLS.INTERNAL_PING_RND);

        } else if (hostnameLower.includes('uat')) {

          pingEnv = decryptUrl(ENCRYPTED_URLS.INTERNAL_PING_UAT);

        } else if (hostnameLower.includes('qa')) {

          pingEnv = 'https://wfsso-apps-qa.pnc.com/idp/startSLO.ping';

        } else {

          pingEnv = 'https://wfsso-apps.pnc.com/idp/startSLO.ping';

        }

        window.location.href = `${pingEnv}?TargetResource=${ltoVfHostNameForLogout}?nocache=${Date.now()}`;

    } else if (hrefLower.includes('clickservonline')) {

        // External: clickservonline site
        if (hostnameLower.startsWith('qa.') || /^www\d*qa\./.test(hostnameLower) || hostnameLower.includes('clickservonline-qa')) {

          // QA external: map subdomain: qa → www, www{N}qa → www{N}, www{N}.clickservonline-qa.com → www{N}
          let targetSubdomain;
          if (hostnameLower.startsWith('qa.')) {
            targetSubdomain = 'www';
          } else if (hostnameLower.includes('clickservonline-qa')) {
            // e.g. www5.clickservonline-qa.com → targetSubdomain = www5
            targetSubdomain = hostnameLower.split('.clickservonline-qa')[0];
          } else {
            const m = hostnameLower.match(/^(www\d*)qa\./);
            targetSubdomain = m ? m[1] : 'www';
          }
          window.location.href = `https://${targetSubdomain}.clickservonline-qa.com`;

        } else {

          // Production external — use actual hostname so clickservonline.com stays on clickservonline.com
          window.location.href = `https://${hostname}`;

        }

    } else {

        window.location.href = '/cli/auth/login';       

    }  

  }
 

export const getAssignReassign = async(setActionType, dealId, getSessionData,setIsDealEditable,setAssignedTo,setAutoAssign,res) => {
  if (dealId !== null && dealId !== undefined && dealId !== '') {
    let userInfo = getSessionData('userInfo');
    let loggedInUser = userInfo ? JSON.parse(userInfo)?.uid?.toLocaleLowerCase(): null;
    if(setAssignedTo) setAssignedTo(res?.primaryAnalystName ||  null);
    if (res?.primaryAnalyst !== '' &&  res?.primaryAnalyst?.toLocaleLowerCase() !== loggedInUser ) {
      setActionType('REASSIGN');
      setIsDealEditable(false);
      setAutoAssign(false);
    } else if (res?.primaryAnalyst == '') {
      setActionType('ASSIGN');
      setIsDealEditable(false);
      setAutoAssign(true);
    } else if (res?.primaryAnalyst !== '') {
      setActionType('UNASSIGN');
      setIsDealEditable(true);
      setAutoAssign(false);
    } else{
      setAutoAssign(false);
      setActionType(null);
    }

  }
  else
    setActionType(null);
   
  return res;
}

export const updateAssignedTo  = async(apiService,apiUrl,dealId) =>{
    let res = await apiService.get(`${apiUrl}api/program/v1/get-program-by-deal-id?dealId=${dealId}`);
    return res?.primaryAnalystName
}

export const CheckOneMoretime = async (publishedEvent, selectedDeals, getSessionData, apiService, apiUrl) => {
  const userInfo = getSessionData('userInfo');
  const loggedInUser = userInfo ? JSON.parse(userInfo)?.uid?.toLocaleLowerCase() : null;
  const dealIds = selectedDeals;
  const responses = await apiService.post(`${apiUrl}api/review/v1/dealAssignmentDetails`, JSON.stringify(dealIds));


  return responses.every((res) => {
    window.__GLOBAL_SERVICE__ = {};
    window.__GLOBAL_SERVICE__.primaryAnalystName = null;
    if (res?.primaryAnalyst !== null && res?.primaryAnalyst?.toLocaleLowerCase() !== loggedInUser) {
      window.__GLOBAL_SERVICE__.primaryAnalystName = res?.primaryAnalystName || null;
      return publishedEvent === 'REASSIGN';
    } else if (res?.primaryAnalyst == null) {
      return publishedEvent === 'ASSIGN';
    } else if (res?.primaryAnalyst !== null) {
      return publishedEvent === 'UNASSIGN';
    }
    return true;
  });
}

export const CheckDealerAccess = async (selectedDeals, res) => {
  let isDealerElgibleToEdit = false;
  const dealId = selectedDeals[0];
  if (res?.isPostappAvailable == 'Y' && res?.isPricingDocgenEligible =='Y' && Object.values(AUTOASSIGN_STATUS).includes(res?.clientStatus)) {
    isDealerElgibleToEdit = true;
  } else if (res?.clientStatus === '29 More Information Requested') {
    isDealerElgibleToEdit = true;
  }
  return isDealerElgibleToEdit;
}


export const DealHasStaleStatus = () =>{

let message =  ["There are one or more deal have stale state kindly refresh your browser to see latest status of deal."];
const response = { openClose: true, message };
return response;
}
 
export const confirmAssignReassign = (publishedEvent, userName, selectedDeals) => {
  let response = {};
  let isEnabled = false;
  if (!publishedEvent?.path || !publishedEvent.value) return response;
  ['underwriting/credit-details','underwriting/list-of-similars'].forEach(element => {
     if (publishedEvent?.path.includes(element)){
      isEnabled = true;
     }
  })
  if(isEnabled) return response;
  let typeOfMessage = selectedDeals?.length>1 ? 'multiple' : 'single';
  // Mapping for paths and their message suffixes
  const pathConfigs = [
    {
      match: "single",
      messages: {
        ASSIGN: ["Are you sure you want to assign this application to yourself?"],
        UNASSIGN: ["Are you sure you want to unassign this application?"],
        REASSIGN: [`This deal is currently assigned to ${userName}`,`Are you sure you want to reassign this application to yourself?`]
      }
    },
    {
      match: "multiple",
      messages: {
        ASSIGN: ["Are you sure you want to assign these applications to yourself?"],
        UNASSIGN: ["Are you sure you want to unassign these applications?"],
        REASSIGN: ["These applications are assigned to other users.  Are you sure you want to reassign these applications to yourself?"]
      }
    }
  ];

  for (const { match, messages } of pathConfigs) {
    if (typeOfMessage.includes(match)) {
      const message = messages[publishedEvent.value];
      if (message) {
        response = { openClose: true, message };
      }
      break;
    }
  }

  return response;
};


export const updateAssignReassign = async ( actionType, setActionType, dealId,  apiService, apiUrl,  getSessionData, 
  setIsDealEditable, setRefreshData, setAssignedTo, setIsCheckAssignmentForDeal, assignedBackToUser,
  CheckAssignment, isCheckAssignmentForDeal, setProgramById) => {
  try {
  const userInfo = getSessionData('userInfo');
       
  const userId = JSON.parse(userInfo).uid?.toLocaleLowerCase();
  const path = window.location.pathname;
  const host = window.location.hostname;
  // Map roles by path or host
  const roleMap = [
    { match: 'clickservonline', id: 2022, type: 'host' },
    { match: 'underwritting', id: 2023, type: 'path' },
    { match: 'underwriting', id: 2023, type: 'path' },
    { match: 'credit-app', id: 2021, type: 'path' },
    { match: 'sales-support', id: 2027, type: 'path' },
    { match: 'sales-queue', id: 2026, type: 'path' }
  ];
  const roleId = roleMap.find(({ match, type }) =>  (type === 'host' ? host : path).includes(match) )?.id || null;
  const underWriterAssign = {  dealIds: dealId, roleId, userId, primaryFlag: 'Y' };
  const assignReassign =  actionType === 'UNASSIGN' ? 'unassignDeals' : 'assignDeals';
  await apiService.post( `${apiUrl}api/underwriting/v1/${assignReassign}`, JSON.stringify(underWriterAssign));
  actionType = path.includes('underwritting/credit-work-queue') || path.includes('sales-support/dashboard')  || path.includes('sales-queue/dashboard')  ? null: actionType;
  const actionMap = {
    UNASSIGN: () => {
      setActionType('ASSIGN');
      setIsDealEditable(false);
      setIsCheckAssignmentForDeal(null);
      setProgramById(null);
      setAssignedTo(null);
    },
    REASSIGN: () => {
      setActionType('UNASSIGN');
      setIsDealEditable(true);
      isCheckAssignmentForDeal === CheckAssignment && setIsCheckAssignmentForDeal(assignedBackToUser);
      const assignTo = JSON.parse(userInfo).firstName +' '+  JSON.parse(userInfo).lastName;
      setAssignedTo(assignTo);
    },
    ASSIGN: () => {
      setIsDealEditable(true);
      const assignTo = JSON.parse(userInfo).firstName +' '+  JSON.parse(userInfo).lastName;
      setAssignedTo(assignTo);
      setActionType('UNASSIGN');
      isCheckAssignmentForDeal === CheckAssignment &&  setIsCheckAssignmentForDeal(assignedBackToUser);
    }
  };
  (actionMap[actionType] || (() => setActionType(null)))();
  setRefreshData(true);
  } catch (error) {
    console.log('Unable to update assign/reasign/unassign : ' + error)
  }
 
};

export const statusCheck = (dealStatus, path, selectedApp=null) => {

  let isAssignReassingAllow = true;
  if(dealStatus == null || path == null ) return true;
  const node = PATH_DEAL_STATUS.find((element) => path.includes(element.path));
 
  if(node){
    if(node.type == 'dontShow')
        isAssignReassingAllow = node['status'].indexOf(dealStatus) > 0;
    else if(node.type == 'show')
      isAssignReassingAllow = node['status'].indexOf(dealStatus) < 0;
  }
  if (selectedApp != null && selectedApp ===PostApplication.DOCUMENTS && path.includes(sales_queue_Path) && dealStatus == autoDocsEmailToParterner) {
    return true;
  }
  return isAssignReassingAllow;
}